import BaseInteractableGeometry from "./base-interactable";

class InteractableCuboid extends BaseInteractableGeometry {
    constructor() {
        super();

        this._w = 1;
        this._h = 1;
        this._d = 1;

        this.width = this.height = this.depth = 1;
    }

    get width() { return this._w; }
    get height() { return this._h; }
    get depth() { return this._d; }
    get volume() { return this._w * this._h * this._h; }

    get formulas() {
        return [
            { name: "width", formula: [{ text: "w", key: "width" }] },
            { name: "height", formula: [{ text: "h", key: "height" }] },
            { name: "depth", formula: [{ text: "d", key: "depth" }] },
            {
                name: "volume", formula: [
                    { text: "w", key: "width" },
                    { text: " * " },
                    { text: "h", key: "height" },
                    { text: " * " },
                    { text: "d", key: "depth" }
                ]
            }
        ];
    }

    set width(v) {
        this._w = v;

        const axes = ["x"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = v;
                o.position[axis] = v * 0.5 - 0.5;
            });
        });
    }

    set depth(v) {
        this._d = v;

        const axes = ["z"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = v;
                o.position[axis] = v * 0.5 - 0.5;
            });
        });
    }

    set height(v) {
        this._h = v;

        const axes = ["y"];

        this.objects.forEach(o => {
            axes.forEach(axis => {
                o.scale[axis] = v;
                o.position[axis] = v * 0.5;
            });
        });
    }

    _createMesh() {
        const geometry = new THREE.BoxBufferGeometry(1, 1, 1);
        const material = new THREE.MeshPhongMaterial({ color: this.colorMesh, transparent: false, opacity: 1 });

        const mesh = new THREE.Mesh(geometry, material);

        mesh.castShadow = true;

        return mesh;
    }

    _createColliders() {
        const { mesh: wMesh, collider: wCollider } = this._createAxisCollider({
            axis: new THREE.Vector3(0, 0, 1),
            angle: Math.PI * 0.5,
            interactableType: "height",
            translation: new THREE.Vector3(-0.5, 0, -0.5),
        });

        const { mesh: hMesh, collider: hCollider } = this._createAxisCollider({
            interactableType: "width",
            translation: new THREE.Vector3(-0.5, -0.5, -0.5),
            halfWidth: true
        });

        const { mesh: dMesh, collider: dCollider } = this._createAxisCollider({
            axis: new THREE.Vector3(0, 1, 0),
            angle: -Math.PI * 0.5,
            interactableType: "depth",
            translation: new THREE.Vector3(-0.5, -0.5, -0.5),
            halfWidth: true
        });

        const colliders = {
            width: wCollider,
            height: hCollider,
            depth: dCollider
        };

        return { objects: [wMesh, hMesh, dMesh], colliders, htmls: [] };
    }
}

export default InteractableCuboid;
export { InteractableCuboid };